import { render, staticRenderFns } from "./PurchaseReturnItem.vue?vue&type=template&id=764eb6ac&"
import script from "./PurchaseReturnItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseReturnItem.vue"
export default component.exports